import { PriceListFilterInput } from "@/gql/graphql";
import { Currencies } from "@/redux/profile/reducers";
import { PriceListFilterStateType } from "../components/price-list-filter/PriceListFilterContext";

const selection = <T>(values: T[]): T[] | undefined =>
  values.length > 0 ? values : undefined;

export type PriceListFilterValidation =
  | { valid: true; input: PriceListFilterInput }
  | { valid: false; missing: string[] };

/**
 * The currency the price list is asked for in.
 *
 * The schema requires one and the backend does not convert anything yet,
 * so whatever is sent makes no difference to what comes back. This stands
 * in for the selector until it does, at which point the currency argument
 * below starts being used again rather than ignored.
 */
const PRICE_LIST_CURRENCY = Currencies.EUR;

export const validatePriceListFilter = (
  filterState: PriceListFilterStateType,
  currency: string
): PriceListFilterValidation => {
  const { from: lengthFrom, to: lengthTo } = filterState.lengthRange;
  const { date, selectedRoutes } = filterState;

  const missing: string[] = [];
  /*
    Not asked for while there is nothing to ask - see PRICE_LIST_CURRENCY.

    if (!currency) {
      missing.push("Currency");
    }
  */
  if (selectedRoutes.length === 0) {
    missing.push("Routes");
  }
  if (lengthFrom == null) {
    missing.push("Length from");
  }
  if (lengthTo == null) {
    missing.push("Length to");
  }
  if (!date) {
    missing.push("Date");
  }

  if (
    selectedRoutes.length === 0 ||
    lengthFrom == null ||
    lengthTo == null ||
    !date
  ) {
    return { valid: false, missing };
  }

  return {
    valid: true,
    input: {
      currency: PRICE_LIST_CURRENCY,
      customerNumbers: selection(
        filterState.selectedCustomers
          .map((customer) => Number(customer.value))
          .filter((customerNumber) => Number.isFinite(customerNumber))
      ),
      sailingCategories: selection(filterState.selectedSailingCategories),
      routes: selectedRoutes.map((route) => route.value),
      vehicleTypes: filterState.vehicleTypeAll
        ? undefined
        : selection(filterState.selectedVehicleTypes.map((vt) => vt.code)),
      lengthFrom,
      lengthTo,
      date,
    },
  };
};
